import { Component, HostListener, Input, OnInit, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'smart-calendar-image-slide',
  templateUrl: './calendar-image-slide.component.html',
  styleUrls: ['./calendar-image-slide.component.scss']
})
export class CalendarImageSlideComponent implements OnInit {
  @Input() mediaList;

  urlUpload: string = environment.URLUPLOADMNG;
  imageSelected = {
    srcUrl: "",
    previewUrl: ""
  }
  imageSelectedIndex = 0;
  imageStartIndex = 0;
  imageEndIndex = 5;
  numberOfpagination = 5;
  constructor() { }

  ngOnInit(): void {
  }

  async ngOnChanges(changes: SimpleChanges) {
    if(changes.mediaList){
      this.imageSelectedIndex = 0;
      this.mediaList = this.mediaList.map(item=>{
        return {
          srcUrl: this.urlUpload+ item.file_path.replace('/app', ''),
          previewUrl: this.urlUpload+ item.file_path.replace('/app', ''),
        }
      })
      this.imageSelected = this.mediaList[this.imageSelectedIndex];
    }
  }

  next(){
    if(this.imageSelectedIndex < this.mediaList.length-1){
      this.imageSelectedIndex = this.imageSelectedIndex + 1;
      this.imageSelected = this.mediaList[this.imageSelectedIndex];
    }
  }

  prev(){
    if(this.imageSelectedIndex > 0){
      this.imageSelectedIndex = this.imageSelectedIndex - 1;
      this.imageSelected = this.mediaList[this.imageSelectedIndex];
    }
  }

  nextChild(){
    if(this.imageEndIndex < this.mediaList.length-1){
      this.imageStartIndex = this.imageStartIndex + 1;
      this.imageEndIndex = this.imageStartIndex + this.numberOfpagination;
    }
  }

  prevChild(){
    if(this.imageEndIndex > this.numberOfpagination){
      this.imageEndIndex = this.imageEndIndex - 1;
      this.imageStartIndex = this.imageEndIndex - this.numberOfpagination;
    }
  }

  select(number){
    this.imageSelectedIndex = number;
    this.imageSelected = this.mediaList[this.imageSelectedIndex];
  }

  downloadFileURL(url) {
    let file_name =  this.genFileName(url);
    
    var url = url;
    var xhr = new XMLHttpRequest();

    xhr.open('GET', url, true);
    xhr.responseType = 'blob';

    xhr.onprogress = function (event) {
        if (event.lengthComputable) {
            var percentComplete = (event.loaded / event.total) * 100;
        }
    };

    xhr.onload = function (event) {
        if (this.status == 200) {
            _saveBlob(this.response, file_name);
        }
        else {}
    };

    xhr.onerror = function (event) {
    };

    xhr.send();
  }

  genFileName(url){
    if(url){
      let file_name =  url.split("/");
      return file_name[file_name.length-1];
    }else{
      return "";
    }
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if(event['keyCode']==37){
      this.prev();
    }else if(event['keyCode']==39){
      this.next();
    }
  }
}

function _saveBlob(response, fileName) {
  if (navigator.msSaveBlob) {
      navigator.msSaveBlob(response, fileName);
  }
  else {
      _html5Saver(response, fileName);
  }
}

function _html5Saver(blob, fileName) {
  var link = document.createElement("a");
  document.body.appendChild(link);
  var url = window.URL.createObjectURL(blob);
  link.href = url;
  link.download = fileName;
  link.click();
  document.body.removeChild(link);
}

